import {getRememberMeCookieField} from 'od-modules/utils/sso.utils';
import xsellGlobalModel from 'od-modules/xsell/data/global_model';
import loginFactory from 'components/user_area/login/js/main';
import prismaHeaderFactory from 'components/prisma_header/js/main';

const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const userHelper = require('od-modules/helpers/user');
const $summaryPanel = $('.summary_panel');
const $membershipIcon = $summaryPanel.find('.membership_icon');
const $myTripsHead = $('.my_trips_head');
const $myTripsHeadButton = $('.my_trips_head_button');
const membershipRefreshPage = userHelper.membershipRefreshPage;
const logoutUser = userHelper.logoutUser;
const submitUserRequest = userHelper.submitUserRequest;
const logoutMemberUser = userHelper.logoutMemberUser;
const $userName = $('.user_name');
const $loginMenu = $('.login_menu');
const $modalView = $('#modalView');
const $numberCircle = $('.number_circle');
const $menuContent = $('.menu_content');
const $menuContentEnhance = $menuContent.length > 0 && Odigeo.UIElements.collapsive.enhance($menuContent, {
    triggerLauncher: 'menuCollapsiveUi',
    collapsePanelDuration: 200,
    expandPanelDuration: 600,
    triggerEvents: true,
    googleAnalyticsOnOpen: {
        type: 'trackEvent',
        data: {
            page: Odigeo.History.getPageNameFromFragment(),
            action: 'header',
            label: Odigeo.Utils.isRequestApp('dp') ? 'menu_open' : 'open_header_menu',
        },
    },
});

const widgetLoader = createWidgetLoader({
    login: ['login-header', loginFactory],
    loginExpired: ['login-expired-login-form', loginFactory, {noHint: Odigeo.Utils.isMobile()}],
    prismaHeader: ['prisma-header', prismaHeaderFactory],
});

const hideShowLoginPanel = function(isLogged, isHomePage) {
    const showMyTrips = Odigeo._.indexOf(['home', 'confirmation', 'mytripslogin', 'mytrips', '', '/'], Odigeo.History.getPageNameFromFragment()) > -1;
    $summaryPanel.find('.header_register_section').toggleClass('hidden', isLogged || !isHomePage);
    $summaryPanel.find('.login_fast_menu').toggleClass('hidden', isLogged || !isHomePage);
    widgetLoader.get('login').execute('hideShowRegisterFooterLink', isHomePage);
    $summaryPanel.toggleClass('od-menu-user-logged', isLogged).toggleClass('logged-on', isLogged);
    $myTripsHeadButton.toggleClass('my_trips_header_logged', isLogged);
    $myTripsHead.toggleClass('hidden', !showMyTrips);
};

const setUserName = function(name, isMembershipRememberMe, isMembership, isPendingToCollect) {
    $summaryPanel.find('.membership_soft_login').toggleClass('odf-hidden', !isMembershipRememberMe);
    $summaryPanel.find('.login_name').text(!Odigeo._.isEmpty(name) && !isMembershipRememberMe ? name : '');
    $summaryPanel.data('softLogin', isMembershipRememberMe);
    widgetLoader.get('login').execute('checkMembershipFastMenu', isMembership, isPendingToCollect);
};

const openedClass = function() {
    return Odigeo.AB.isCssVariationHeaderDesktop ? 'opened prisma-btn-active' : 'opened';
};

const userEventController = {
    globalEvents: {
        /** Login Widget */
        'login-header:submitUserRequest': 'onSubmitUserRequest',
        'login-header:userLogged': 'onUserLogged',
        'login-header:setMembershipStar': 'onSetMembershipStar',
        'login-header:setLoginAndSecurityFastMenu': 'onSetLoginAndSecurityFastMenu',
        'login-header:membershipLogoutPopUpConfirmation': 'onMembershipLogoutPopUpConfirmation',
        'login-header:userLogoutConfirmed': 'onUserLogoutConfirmed',
        'users-manager:updateAccountInfoOk': 'onUpdateDisplayName',
        'my-trips-login-form:userLogged': 'onUserLoggedMyTrips',
        'login-header:userNotLogged': 'onUserNotLogged',
        'login-header:userIsLogged': 'onIsUserLogged',
        'login-header:openRegister': 'onOpenRegister',
        'login-expired-manager:initEmbedLogin': 'initEmbedLogin',
        /** Is logged */
        'users-manager:isLoggedInOk': 'onLoginEvents',
        'users-manager:isLoggedInWithError': 'onLoginEvents',
        'users-manager:isLoggedInError': 'onLoginEvents',
        /** Login */
        'users-manager:loginOk': 'onLoginEvents',
        'users-manager:loginWithError': 'onLoginEventsSeparately',
        'users-manager:loginError': 'onLoginEventsSeparately',
        'users-manager:membershipLogInServerConfirmation': 'onMembershipLogInServerConfirmation',
        /** Logout */
        'users-manager:logOutOk': Odigeo.Utils.isMobile() ? 'onLoginEvents' : 'onLogout',
        'users-manager:membershipLogoutServerConfirmation': 'onMembershipLogoutServerConfirmation',
        /** Login with Facebook */
        'users-manager:loginWithFacebookOk': 'onLoginEventsSeparately',
        'users-manager:loginWithFacebookWithError': 'onLoginEventsSeparately',
        'users-manager:loginWithFacebookError': 'onLoginEventsSeparately',
        'users-manager:getAccountInfoWithError': 'onGetDataError',
        'users-manager:getAccountInfoError': 'onGetDataError',
        /** Login with Google */
        'users-manager:loginWithGoogleOk': 'onLoginEventsSeparately',
        'users-manager:loginWithGoogleWithError': 'onLoginEventsSeparately',
        'users-manager:loginWithGoogleError': 'onLoginEventsSeparately',
        /** Recover password */
        'users-manager:recoverPasswordOk': 'onLoginEventsSeparately',
        'users-manager:recoverPasswordWithError': 'onLoginEventsSeparately',
        'users-manager:recoverPasswordError': 'onLoginEventsSeparately',
        /** Open/Close login form */
        'login-header:openLoginForm': 'onOpenLoginForm',
        'frontend-shell:openLogin': 'onOpenLoginForm',
        'frontend-shell:showUserHeader': 'onShowUserHeader',
        'prisma-header:openLoginForm': 'onOpenLoginForm',
        'account-blocked:openLoginForm': 'onOpenLoginForm',
        'register-manager:openLoginForm': 'onOpenLoginForm',
        'register-manager:closeLoginForm': 'onCloseLoginForm',
        'reset-password:openLoginForm': 'onOpenLoginForm',
        /** Modal view */
        'register-manager:showHideModalLayer': 'onShowHideModalLayer',
        'reset-password:showHideModalLayer': 'onShowHideModalLayer',
        'payment-manager:showHideModalLayer': 'onShowHideModalLayer',
        /** Remember me Widget */
        'rememberme:submitUserRequest': 'onSubmitUserRequest',
        /** Frequent Passengers Manager */
        'frequent-passengers-manager:ssoRememberMeCookieUpdated': 'onSsoRememberMeCookieUpdated',
        'flightDetails:owcSpecialRulesShow': 'onShowModalLayer',
        'flightDetails:owcSpecialRulesHide': 'onHideModalLayer',
        /** Footer */
        'footer:hideLegalFooter': 'onHideLegalFooter',
        /** Menu */
        'prisma-header:toggleUserAreaMenu': 'onToggleUserAreaMenu',
        'burger-menu:toggleMainMenu': 'onToggleMainMenu',
    },
    viewEvents: {
        'sessionExpireDialog:repeatSearchDynpack': 'onRepeatSearch',
    },
    eventHandlers: {
        onShowHideModalLayer: function(isVisible) {
            if (Odigeo.Utils.isMobile()) {
                $modalView.toggleClass('active', isVisible);
            } else {
                $('#login-header').find('.modal_view').toggleClass('active', isVisible);
            }
        },

        onIsUserLogged: function(isLogged) {
            if (!Odigeo._.isNull(Odigeo.Utils.readCookie('sso_remember_me'))) {
                isLogged = true;
            }
            hideShowLoginPanel(isLogged, Odigeo.Utils.isHomePage());
        },

        onOpenRegister: function() {
            if (Odigeo.History.getPageNameFromFragment() === 'register') {
                widgetLoader.get('login').execute('closeConnectorsLayer');
            } else {
                Odigeo.Router.navigate('user-register');
            }
        },

        onToggleUserAreaMenu: function() {
            Odigeo.requireWidget('home-page-burger-menu', 'burger_menu', function(burgerMenu) {
                burgerMenu.execute('onToggleUserAreaMenu');
            });
        },

        onToggleMainMenu: function() {
            $modalView.toggleClass('active', false);
            $menuContentEnhance.trigger('collapsePanel');
        },

        onHideModalLayer: function() {
            this.onShowHideModalLayer(false);
        },

        onShowModalLayer: function() {
            this.onShowHideModalLayer(true);
        },

        onUserLogged: function(data, throwGlobal, event) {
            const userName = data.displayName;
            const isMembership = data.membership;
            const userDTO = data.userDTO;
            const membershipStatus = Odigeo._.get(userDTO, 'membershipInfoDTO.membershipDTO.status');
            const isPendingToCollect = membershipStatus === 'PENDING_TO_COLLECT';

            if (Odigeo.Utils.isDesktop()) {
                setUserName(userName, null, isMembership, isPendingToCollect);
                hideShowLoginPanel(true, false);
                $summaryPanel.off().on(Odigeo.Events.tap, function(e) {
                    e.stopPropagation();
                    const isNotDisplayed = !$summaryPanel.find('.logged_fast_menu').hasClass(openedClass());
                    Odigeo.trigger('closeAllPopUps');
                    $('.header_menu_list').find('.opened').not('.prevent_close_on_tap').removeClass(openedClass());
                    if (Odigeo.AB.isCssVariationHeaderDesktop) {
                        if (isNotDisplayed) {
                            $summaryPanel.find('.logged_fast_menu').addClass(openedClass());
                            $summaryPanel.find('.user_logged .prisma-btn').addClass(openedClass());
                        }
                    } else {
                        $summaryPanel.find('.logged_fast_menu').toggleClass(openedClass());
                        $summaryPanel.find('.user_logged .prisma-btn').toggleClass(openedClass());
                    }
                });
            } else {
                $userName.text(' (' + userName + ')').removeClass('hidden');
                $loginMenu.addClass('logged');
                $numberCircle.eq(1).addClass('odf-hidden');
            }
            Odigeo.trigger(Odigeo.Utils.isMobile() || !!throwGlobal || !event ? 'global:userLogged' : event, Odigeo._.isObject(data) ? data : {});
        },

        onSetMembershipStar: function(isMembership) {
            $membershipIcon.toggleClass('odf-hidden', !isMembership);
        },
        onSetLoginAndSecurityFastMenu: function(isMembership, isPendingToCollect) {
            const loginAndSecurityMembershipFastMenuItem = ($summaryPanel.find('.login_and_security_membership_fast_menu_item'));
            loginAndSecurityMembershipFastMenuItem.toggleClass('odf-hidden', !(isMembership || isPendingToCollect));
        },
        onUserLoggedMyTrips: function(data) {
            widgetLoader.get('login').execute('setLogged');
            this.onUserLogged(data, false, 'my-trips-login-form:userLoggedMT');
        },

        onUpdateDisplayName: function(data) {
            if (!Odigeo._.isEmpty(data.displayName)) {
                setUserName(data.displayName);
            }
        },

        onUserNotLogged: function() {
            if (Odigeo.Utils.isMobile()) {
                const hasCookie = !Odigeo._.isNull(Odigeo.Utils.readCookie('sso_remember_me'));
                if (hasCookie) {
                    $userName.text(' (' + getRememberMeCookieField('name') + ')');
                }
                $userName.toggleClass('hidden', !hasCookie);
                $loginMenu.toggleClass('logged', hasCookie);
                $numberCircle.eq(1).toggleClass('odf-hidden', hasCookie);
                Odigeo.trigger(hasCookie ? 'global:userNotLoggedRemembered' : 'global:userNotLogged');
            } else {
                const isHomePage = Odigeo.Utils.isHomePage();
                let name;
                let isMembershipRememberMe;
                // If not logged we have to check if the user has a "remember me" cookie
                if (Odigeo._.isNull(Odigeo.Utils.readCookie('sso_remember_me'))) {
                    hideShowLoginPanel(false, isHomePage);
                    if (isHomePage) {
                        $summaryPanel.off().on(Odigeo.Events.mouseover, function() {
                            Odigeo.trigger('closeAllPopUps');
                            $('.header_menu_list').find('.opened').not('.prevent_close_on_tap').removeClass(openedClass());
                            $summaryPanel.addClass(openedClass());
                        }).on(Odigeo.Events.mouseout, function() {
                            Odigeo.trigger('closeAllPopUps');
                            $('.header_menu_list').find('.opened').not('.prevent_close_on_tap').removeClass(openedClass());
                            $summaryPanel.removeClass(openedClass());
                        });
                    }
                    Odigeo.trigger('global:userNotLogged');
                } else {
                    name = getRememberMeCookieField('name');
                    isMembershipRememberMe = getRememberMeCookieField('isMembership') === 'true';
                    setUserName(name, isMembershipRememberMe);
                    hideShowLoginPanel(true, false);
                    if (!isMembershipRememberMe) {
                        $summaryPanel.off().on(Odigeo.Events.tap, function(e) {
                            e.stopPropagation();
                            $summaryPanel.find('.logged_fast_menu').toggleClass(openedClass());
                            $summaryPanel.find('.user_logged .prisma-btn').toggleClass(openedClass());
                        });
                    }
                    Odigeo.trigger('global:userNotLoggedRemembered');
                }
            }
        },

        onSubmitUserRequest: function(data) {
            submitUserRequest(data);
        },

        onLogout: function(data) {
            xsellGlobalModel.set('isPrimeUser', false);
            Odigeo.trigger('global:userLogout');
            widgetLoader.get('login').execute(data.action, data);
        },

        onLoginEvents: function(data) {
            xsellGlobalModel.set('isPrimeUser', data.membership);
            if (Odigeo.Utils.isMobile() && Odigeo.AB.prismaHeader !== 1) {
                widgetLoader.get('prismaHeader').execute('update', {page: Odigeo.History.getPageNameFromFragment(), userData: data.userDTO});
            }
            Odigeo.trigger('global:' + data.action, data);
            widgetLoader.get('login').execute(data.action, data);
        },

        onLoginEventsSeparately: function(data) {
            xsellGlobalModel.set('isPrimeUser', data.membership);
            const widgetId = Odigeo.Session.get('loginWidget') || 'login-header';
            widgetLoader.get('login', widgetId).execute(data.action, data);
        },

        onRepeatSearch: function() {
            Odigeo.trigger('sessionExpireDialog:repeatSearch', Odigeo.History.getPageNameFromFragment());
        },

        onUserLogoutConfirmed: logoutUser,

        onMembershipLogoutPopUpConfirmation: logoutMemberUser,

        onMembershipLogoutServerConfirmation: Odigeo._.partial(membershipRefreshPage, 'logout'),

        onMembershipLogInServerConfirmation: function() {
            membershipRefreshPage('login');
        },

        onOpenLoginForm: function() {
            widgetLoader.get('login').execute('openModalLogin');
        },

        onShowUserHeader: ({isToken, isLogged}) => {
            if (Odigeo.Utils.isDesktop()) {
                const headerCTAs = $summaryPanel.find('.header_login_button');
                const headerActions = {
                    'login': isLogged || isToken,
                    'find-booking': !isToken && !isLogged,
                    'login-redirection': !isToken && !isLogged,
                };
                Object.entries(headerActions).forEach(([action, status]) => {
                    headerCTAs.filter(`[data-action='${action}']`).toggleClass('odf-hidden', !status);
                });
            } else {
                widgetLoader.get('prismaHeader').execute('update', {page: Odigeo.History.getPageNameFromFragment(),
                    of2UserData: {isToken, isLogged}});
            }
        },
        onCloseLoginForm: function() {
            widgetLoader.get('login').execute('closeConnectorsLayer');
        },

        initEmbedLogin(typeLogin) {
            widgetLoader.get('loginExpired').execute('initEmbedView', typeLogin);
        },

        onGetDataError: function() {
            Odigeo.trigger('global:onGetDataError');
        },

        onSsoRememberMeCookieUpdated: function() {
            const displayName = getRememberMeCookieField('name');
            setUserName(displayName || '');
        },

        onHideLegalFooter: function() {
            const $page = $('#page');
            const $footerLegal = $page.find('.footer_legal_copyright');
            if ($footerLegal.length > 0) {
                $footerLegal.addClass('odf-hidden');
            }
        },
    },
};

export default userEventController;
